import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Checkout.css';

export const CheckoutSuccess: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshOrganization } = useAuth();
  const [isRefreshing, setIsRefreshing] = useState(true);

  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Refresh organization data to get updated subscription info
    const refreshData = async () => {
      try {
        await refreshOrganization();
      } catch (error) {
        console.error('Error refreshing organization:', error);
      } finally {
        setIsRefreshing(false);
      }
    };

    // Small delay to ensure Stripe webhook has processed
    const timer = setTimeout(refreshData, 2000);
    return () => clearTimeout(timer);
  }, [refreshOrganization]);

  return (
    <div className="checkout-page">
      <div className="checkout-container">
        <div className="checkout-card success">
          <div className="checkout-icon success-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22,4 12,14.01 9,11.01" />
            </svg>
          </div>

          <h1>Pagamento Confirmado!</h1>

          <p className="checkout-message">
            Sua assinatura foi ativada com sucesso. Você já pode aproveitar todos os recursos do seu novo plano.
          </p>

          {isRefreshing ? (
            <div className="checkout-loading">
              <div className="spinner-small"></div>
              <span>Atualizando sua conta...</span>
            </div>
          ) : (
            <div className="checkout-actions">
              <button
                className="btn btn-primary btn-lg"
                onClick={() => navigate('/dashboard')}
              >
                Ir para o Dashboard
              </button>
              <button
                className="btn btn-outline"
                onClick={() => navigate('/settings')}
              >
                Ver Configurações
              </button>
            </div>
          )}

          {sessionId && (
            <p className="checkout-session-id">
              ID da sessão: <code>{sessionId.substring(0, 20)}...</code>
            </p>
          )}
        </div>

        <div className="checkout-help">
          <p>
            Precisa de ajuda? Entre em contato com nosso suporte em{' '}
            <a href="mailto:suporte@ghiconnect.com">suporte@ghiconnect.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};
